import {z} from 'zod'

export const ApplicationCountrySchema = z.object({
  id: z.number(),
  name: z.string(),
  code: z.string(),
})

export const ApplicationSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  countries: z.array(ApplicationCountrySchema),
})

export const GetApplicationsResponseSchema = z.object({
  applications: z.array(ApplicationSchema),
})

export const GetApplicationsRequestSchema = z.void()

export type Application = z.infer<typeof ApplicationSchema>
export type GetApplicationsResponse = z.infer<typeof GetApplicationsResponseSchema>
export type GetApplicationsRequest = z.infer<typeof GetApplicationsRequestSchema>
